import { PText, PTextFieldWrapper } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { checkIctoExistence } from '../../utils/api/Apps'

import { PortalContext } from '../../utils/PortalContext'

import styles from './ictofield.module.css'

type Props = {
  defaultValue?: any
}

const IctoField = ({ defaultValue }: Props) => {
  const { setError, setToastContent, setToast } = React.useContext(PortalContext)
  const newDefaultValue = defaultValue?.replace(/ICTO-/gi, '')
  const { register, errors, setValue } = useFormContext()

  const checkICTO = async (value: number) => {
    if (value === newDefaultValue) return

    const res = await checkIctoExistence('ICTO-' + value)
      .then((response) => response.json())
      .then((data) => {
        return data.result
      })
      .catch((err) => {
        setError(true)
        setToastContent(err.message)
        setToast(true)
      })
    return !res
  }

  React.useEffect(() => {
    if (defaultValue) {
      setValue('icto', newDefaultValue, {
        shouldValidate: true
      })
    }
  }, [defaultValue])

  React.useEffect(() => {
    register('icto', {
      required: 'Dieses Feld wird benötigt.',
      validate: {
        checkExistence: (value) => checkICTO(value)
      }
    })
  }, [register])

  return (
    <PTextFieldWrapper
      label='PlanningIT ICTO'
      className={styles.textfield}
      state={errors.icto ? 'error' : 'none'}
      unit='ICTO-'
      message={errors.icto?.type === 'checkExistence' ? 'Die ICTO Nr. existiert bereits' : errors.icto?.message}
    >
      <input
        type='number'
        required
        name='icto'
        placeholder='XXX'
        ref={register}
        className={clsx(styles.ictoField, { [styles.error]: errors.icto })}
        defaultValue={newDefaultValue}
      />
    </PTextFieldWrapper>
  )
}

export default IctoField
